var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11C8.75 9.48122 9.98122 8.25 11.5 8.25C13.0188 8.25 14.25 9.48122 14.25 11C14.25 12.5188 13.0188 13.75 11.5 13.75C9.98122 13.75 8.75 12.5188 8.75 11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.8889C2.5 5.97969 6.52944 2 11.5 2C16.4706 2 20.5 5.97969 20.5 10.8889C20.5 16.2006 15.429 20.041 12.2799 21.6333C11.7877 21.8821 11.2123 21.8821 10.7201 21.6333C7.57101 20.041 2.5 16.2006 2.5 10.8889ZM11.5 6.75C9.15279 6.75 7.25 8.65279 7.25 11C7.25 13.3472 9.15279 15.25 11.5 15.25C12.4027 15.25 13.2397 14.9686 13.928 14.4886L15.4697 16.0303C15.7626 16.3232 16.2374 16.3232 16.5303 16.0303C16.8232 15.7374 16.8232 15.2626 16.5303 14.9697L14.9886 13.428C15.4686 12.7397 15.75 11.9027 15.75 11C15.75 8.65279 13.8472 6.75 11.5 6.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLocation);
export default __webpack_public_path__ + "static/media/search-location.da80e2eff05ca3c9f78fc6c73af99b33.svg";
export { ForwardRef as ReactComponent };